import React from 'react';
import { useSearchParams } from 'react-router-dom-v5-compat';
import { HeaderWithClose } from './headerWithClose';
import { useAlleTreatments } from '@packages/core-split-feature-flag/src/useAlleTreatments';
import { PartnerIntegrations } from '../../helpers/partnerIntegrations';
import { piFeatureKeys } from '@packages/core-split-feature-flag/src/consumer';

const HeaderWithCloseWrapper: React.FunctionComponent = () => {
  const piFF = useAlleTreatments({
    splitNames: [piFeatureKeys.partnerIntegrationsEnabled],
  })[piFeatureKeys.partnerIntegrationsEnabled]?.treatment;

  const partnerIntegrationsEnabled =
    piFF === 'on' && PartnerIntegrations.isPartnerSite();
  const [searchParams] = useSearchParams();

  const logoLinkTo = partnerIntegrationsEnabled
    ? PartnerIntegrations.getAlleUrl()
    : undefined;

  const closeLinkTo = partnerIntegrationsEnabled
    ? PartnerIntegrations.getPartnerRedirectUri(searchParams)
    : undefined;

  return <HeaderWithClose closeLinkTo={closeLinkTo} logoLinkTo={logoLinkTo} />;
};

export { HeaderWithCloseWrapper };
